import abortionEvent    from './abortionEvent'
import vaccinationEvent from './vaccinationEvent'

export default {
    abortionEvent,
    vaccinationEvent
};
